import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from '../service/http.service';
import { Booking } from '../booking';
import { Vademecum } from '../vademecum';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-edit-booking-vademecum',
  templateUrl: './edit-booking-vademecum.component.html',
  styleUrls: ['./edit-booking-vademecum.component.css']
})
export class EditBookingVademecumComponent implements OnInit {

  @Input()
  booking!: Booking;

  vademecum!: Vademecum;
  pdfVademecumUrl!: SafeResourceUrl;

  constructor(
    private httpService: HttpService,
    private sanitizer: DomSanitizer,
    public userService: UserService
  ) { }

  ngOnInit() {
    if(this.booking){
      this.httpService.getVademecumByBookingId(this.booking.id!)
      .subscribe(vademecum =>{
        this.vademecum = vademecum;
      });
      this.httpService.getPdfBlob(this.booking.id!, this.booking.student.language.name)
      .subscribe(blob => {
          this.pdfVademecumUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        }
      );
    } 
  }

}
